import { makeStyles } from "@saleor/macaw-ui";

export const useStyles = makeStyles(
  () => ({
    list: {
      margin: 0,
      paddingLeft: "16px",
    },
  }),
  { name: "AppPermissions" },
);
